const data = (collection, keyword, status) => (
  collection
    && Object.values(collection).filter((item) => {
      let available = false;
      let statusAvailable = true;
      if (status === 'active') {
        statusAvailable = item.attributes.deleted_at === '';
      }
      if (status === 'deleted') {
        statusAvailable = item.attributes.deleted_at !== '';
      }

      if (
        (
          item.attributes.affiliate_name
            .toLowerCase()
            .includes(keyword.toLowerCase())
          || item.attributes.company
            .toLowerCase()
            .includes(keyword.toLowerCase())
          || item.attributes.contact
            .toLowerCase()
            .includes(keyword.toLowerCase())
          || item.attributes.email
            .toLowerCase()
            .includes(keyword.toLowerCase())
          || item.attributes.website
            .toLowerCase()
            .includes(keyword.toLowerCase())
        ) && statusAvailable
      ) { available = true; }

      return available;
    })
);

export default data;
